import { render, staticRenderFns } from "./base-info.vue?vue&type=template&id=a7b893cc&scoped=true&functional=true"
import script from "./base-info.vue?vue&type=script&lang=js"
export * from "./base-info.vue?vue&type=script&lang=js"
import style0 from "./base-info.vue?vue&type=style&index=0&id=a7b893cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "a7b893cc",
  null
  
)

export default component.exports